import * as React from 'react';

import {PromoState} from 'shells/promo-state-overlay/promo-state';
import type {PromoStateProps} from 'shells/promo-state-overlay/promo-state';

import styles from './promo-state-overlay.module.css';

type Offset = {
    top: number;
    left: number;
};

type Props = {
    promoStateProps?: PromoStateProps;
    offset?: Offset;
    align?: 'right' | 'center' | 'left';
};

export function PromoStateOverlay(props: Props) {
    // @ts-expect-error
    function getAlignmentClass(align) {
        switch (align) {
            case 'left':
                return 'flex-start';
            case 'right':
                return 'flex-end';
            case 'center':
                return 'center';
            default:
                return 'center';
        }
    }

    return (
        <div
            style={{
                top: props.offset && props.offset.top,
                left: props.offset && props.offset.left,
                justifyContent: getAlignmentClass(props.align),
            }}
            className={styles.overlay}
        >
            {/* @ts-expect-error */}
            <PromoState {...props.promoStateProps} />
        </div>
    );
}
